import { MobileProfileList } from './List';

export { MobileProfileList as List }
export default { List: MobileProfileList }
